<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <header class="has-text-centered">
        <p class="is-size-5 has-text-weight-bold">
          {{ $t('detailCommande.indexation.popUp.titleEcheancier') }}
        </p>
      </header>
      <section class="mgt-4">
        <div class="columns is-multiline">
          <div class="column is-4 pdv-1">
            <b-field
              :label="$t('detailCommande.indexation.pourcentageTheorique')"
              custom-class="is-italic has-text-weight-light mgb-0">
              <span>
                {{ func.formatPercent(echeancier.indexation.pourcentageTheorique) }}
              </span>
            </b-field>
          </div>
          <div class="column is-4 pdv-1">
            <b-field
              :label="$t('detailCommande.indexation.valeurIndexationReference')"
              custom-class="is-italic has-text-weight-light mgb-0">
              <span>
                {{ echeancier.indexation.valeurIndiceReference }}
              </span>
            </b-field>
          </div>
          <div class="column is-4 pdv-1">
            <b-field
              :label="$t('detailCommande.indexation.dateIndexationReference')"
              custom-class="is-italic has-text-weight-light mgb-0">
              <span>
                {{ func.formatDate(echeancier.indexation.dateIndiceReference) }}
              </span>
            </b-field>
          </div>
          <div class="column is-4 pdv-1">
            <b-field
              :label="$t('detailCommande.indexation.pourcentageReel')"
              custom-class="is-italic has-text-weight-light mgb-0">
              <span>
                {{ func.formatPercent(echeancier.indexation.pourcentageReel) }}
              </span>
            </b-field>
          </div>
          <div class="column is-4 pdv-1">
            <b-field
              :label="$t('detailCommande.indexation.valeurIndexationActuel')"
              custom-class="is-italic has-text-weight-light mgb-0">
              <span>
                {{ echeancier.indexation.valeurIndiceActuel }}
              </span>
            </b-field>
          </div>
          <div class="column pdv-1 is-4">
            <b-field
              :label="$t('detailCommande.indexation.dateIndexationActuel')"
              custom-class="is-italic has-text-weight-light mgb-0">
              <span>
                {{ func.formatDate(echeancier.indexation.dateIndiceActuel) }}
              </span>
            </b-field>
          </div>
          <div class="column pdv-1 is-4">
            <b-field
              :label="$t('detailCommande.indexation.montantReference')"
              custom-class="is-italic has-text-weight-light mgb-0">
              <span>
                {{ func.formatDevise(echeancier.indexation.montantReference) }}
              </span>
            </b-field>
          </div>
          <div class="column pdv-1 is-4">
            <b-field
              :label="$t('detailCommande.indexation.montantActuel')"
              custom-class="is-italic has-text-weight-light mgb-0">
              <span>
                {{ func.formatDevise(echeancier.montant) }}
              </span>
            </b-field>
          </div>
          <div class="column pdv-1 is-4">
            <b-field
              :label="$t('detailCommande.indexation.dateDerniereIndexation')"
              custom-class="is-italic has-text-weight-light mgb-0">
              <span>
                {{ func.formatDate(echeancier.indexation.dateDerniereIndexation) }}
              </span>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="mgt-4">
        <div class="buttons">
          <button
            class="button has-text-centered"
            @click="$emit('close')">
            {{ $t('general.button.cancel') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import formatDate from '@/services/general/formatDate';
import { formatDevise } from '@/services/general/filters/formatDevise';
import formatPercent from '@/services/general/filters/formatPercent';

export default {
  props: {
    echeancier: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      func: {
        formatDate,
        formatDevise,
        formatPercent,
      },
    };
  },
};
</script>
